import './Navbar.css';
import React from 'react';
import { Icon } from '../Icon/Icon';
import { NavbarSearch } from '../NavbarSearch/NavbarSearch';
import { writeDB } from '../../model/store';
import { useMetaContent } from '../../model/meta';
import { history } from '../../model/history';
import { useData, useRemoteData } from '../../model/data';
import { Avatar } from '../Avatar/Avatar';
import { Button } from '../Button/Button';
import { destroySession } from '../../model/session';
import { companyPath } from '../../routes';
import { NavLink } from 'react-router-dom';
import { Tooltip } from '../Tooltip/Tooltip';
import { getUser, fullUserName } from '../../model/user';
import { t } from '../../locales/translate';
import { useSelectedMembership } from '../../model/membership';
import { useErrorHandler } from '../../util/util';

export function Navbar(): JSX.Element {
  const { breadcrumbs: rawBreadcrumbs, title } = useMetaContent();
  const breadcrumbs = rawBreadcrumbs || (title ? [{ title, url: undefined }] : []);
  const session = useData((db) => db.get('session'));
  const membership = useSelectedMembership();
  const [user, , error] = useRemoteData(
    () => getUser((session && session.userId) || ''),
    (db) => db.table('users').find((session && session.userId) || '')
  ); // Todo handle loading

  useErrorHandler(error);

  return (
    <nav className="navbar">
      <section className="navbar__section">
        <Icon
          className="navbar__toggle"
          name="menu"
          onClick={() => writeDB.set('sidebarOpen', !writeDB.get('sidebarOpen'))}
        />
      </section>
      <section className="navbar__section">
        <div className="navbar__breadcrumbs">
          {breadcrumbs.map((crumb, index) => {
            if (crumb.url) {
              return (
                <NavLink
                  key={`navbar-breadcrumb-${index}`} // on first render sometimes the title is undefined
                  className="navbar__breadcrumb"
                  to={crumb.url || history.location}
                >
                  {crumb.title}
                </NavLink>
              );
            } else {
              return (
                <span className="navbar__breadcrumb" key={crumb.title}>
                  {crumb.title}
                </span>
              );
            }
          })}
        </div>
      </section>
      <section className="navbar__section navbar__search">
        <NavbarSearch />
      </section>
      <section className="navbar__section navbar__section--profile">
        <Tooltip
          position="bottom-end"
          arrow={false}
          mode="click"
          gap="none"
          rounded={false}
          reference={
            <Avatar
              className="navbar__account"
              name={`${user?.firstName?.charAt(0)}${user?.lastName?.charAt(0)}`}
              image={user?.avatar?.url}
              rounded
            />
          }
        >
          <div className="navbar__account-details">
            <div>{fullUserName(user)}</div>
            <Button title={t.general.logout} onClick={() => destroySession()} />
          </div>
        </Tooltip>
        {membership && (
          <div onClick={() => history.push(companyPath(membership.company))}>
            <Avatar
              name={membership.company.name || ''}
              image={membership.company.icon && membership.company.icon.url}
            />
          </div>
        )}
      </section>
    </nav>
  );
}
